import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { ExtendableStyles } from 'utils-next/types'

import { Theme, Typography } from '@mui/material'

export type DealRelaxedSweetSpotDefinitionProps = ExtendableStyles & {
  relaxedSweetSpotDefinition: string
}

export function DealRelaxedSweetSpotDefinition({
  relaxedSweetSpotDefinition,
  ...otherProps
}: DealRelaxedSweetSpotDefinitionProps) {
  const { classes } = useStyles()

  return (
    <div {...otherProps}>
      <Typography className={classes.title} variant="body1" gutterBottom>
        Relaxed spot of the Space
      </Typography>
      <Typography variant="body1">
        {relaxedSweetSpotDefinition ? (
          <span dangerouslySetInnerHTML={{ __html: relaxedSweetSpotDefinition }} />
        ) : (
          <span>N/A</span>
        )}
      </Typography>
    </div>
  )
}

const useStyles = makeStyles()(({ typography }: Theme) => ({
  title: {
    fontWeight: typography.fontWeightBold,
  },
}))
